import { optional, record, string, size, type, array, unknown } from 'superstruct';
import { Integer } from '../../../../superstruct/integer';
export const SingleItemPayload = type({
    id: Integer,
    quantity: Integer,
    properties: optional(record(string(), unknown())),
    selling_plan: optional(Integer)
});
export const Payload = type({
    items: size(array(SingleItemPayload), 1, Infinity)
});
